import { render, staticRenderFns } from "./BlockRulesHome.vue?vue&type=template&id=1fae972c&scoped=true&"
import script from "./BlockRulesHome.vue?vue&type=script&lang=ts&"
export * from "./BlockRulesHome.vue?vue&type=script&lang=ts&"
import style0 from "./BlockRulesHome.vue?vue&type=style&index=0&id=1fae972c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae972c",
  null
  
)

export default component.exports